import HomeApi from '@/api/home';
import { setStorageSync } from '@tarojs/taro';

interface CityLocation {
  name: string;
  code: number;
}

export type GlobalModelTypeState = {
  token: string;
  location: CityLocation;
  needRefresh: boolean;
};
export type GlobalModelType = {
  namespace: string;
  state: GlobalModelTypeState;
  effects: {
    getUserLocation: any;
  };
  reducers: {
    updateState: any;
  };
};

const global: GlobalModelType = {
  namespace: 'global',
  state: {
    token: '',
    location: {} as CityLocation,
    needRefresh: true
  },
  reducers: {
    // 同步方法
    updateState(state: any, { payload }: any) {
      return { ...state, ...payload };
    }
  },
  effects: {
    *getUserLocation({ payload }: any, { call, put }: any) {
      const res = yield call(HomeApi.getUserLocation, payload);
      if (res) {
        const { data } = res;
        const currentCity = {
          name: data?.cityShort,
          code: data?.cityCode
        };
        setStorageSync('h5-location', JSON.stringify(currentCity)); // 获取的定位存到内存中
        setStorageSync('h5-cityCode', data?.cityCode);
        yield put({
          type: 'updateState',
          payload: {
            location: currentCity
          }
        });
      }
    }
  }
};
export default global;
